// extracted by mini-css-extract-plugin
export default {"info-row":"info-row_info-row__W-BW8","full-line":"info-row_full-line__MHIxH"};